import { getPath } from '@/router/common'

const baseUrl = {
  title: '改单审批',
  path: 'FinancialInstruments'
}

export default [
  {
    path: getPath('ChangeWaybill', baseUrl),
    name: 'FinancialInstruments_ChangeWaybill',
    component: () => import(/* webpackChunkName: "FinancialInstruments_ChangeWaybill" */ '@/views/financialInstruments/changeWaybill/index.vue'),
    meta: {
      title: '改单审批'
    }
  },
  {
    path: getPath('ReverseWriteOff', baseUrl),
    name: 'FinancialInstruments_ReverseWriteOff',
    component: () => import(/* webpackChunkName: "FinancialInstruments_ReverseWriteOff" */ '@/views/financialInstruments/reverseWriteOff/index.vue'),
    meta: {
      title: '反核销'
    }
  },
  {
    path: getPath('CustomerMerger', baseUrl),
    name: 'FinancialInstruments_CustomerMerger',
    component: () => import(/* webpackChunkName: "FinancialInstruments_CustomerMerger" */ '@/views/financialInstruments/customerMerger/index.vue'),
    meta: {
      title: '客户合并'
    }
  },
  {
    path: getPath('ProxyMerger', baseUrl),
    name: 'FinancialInstruments_ProxyMerger',
    component: () => import(/* webpackChunkName: "FinancialInstruments_ProxyMerger" */ '@/views/financialInstruments/proxyMerger/index.vue'),
    meta: {
      title: '代理合并'
    }
  },
  {
    path: getPath('Modifybill', baseUrl),
    name: 'FinancialInstruments_Modifybill',
    component: () => import(/* webpackChunkName: "FinancialInstruments_Modifybill" */ '@/views/financialInstruments/modifybill/index.vue'),
    meta: {
      title: '确认改单'
    }
  },
  {
    path: getPath('CheackTallyCertificate', baseUrl),
    name: 'FinancialInstruments_CheackTallyCertificate',
    component: () => import(/* webpackChunkName: "FinancialInstruments_CheackTallyCertificate" */ '@/views/financialInstruments/cheackTallyCertificate/index.vue'),
    meta: {
      title: '记账凭证'
    }
  }
]
